

import { ArrowUpDown, ArrowUp, ArrowDown } from "lucide-react";

type SortField = 'name' | 'total_assigned' | 'total_paid' | 'balance' | 'status';

interface SortControlsProps {
  sortField: SortField;
  sortDirection: 'asc' | 'desc';
  onSort: (field: SortField) => void;
  itemsPerPage: number;
  onItemsPerPageChange: (value: number) => void;
}

export function SortControls({
  sortField,
  sortDirection,
  onSort,
  itemsPerPage,
  onItemsPerPageChange,
}: SortControlsProps) {
  const getSortIcon = (field: SortField) => {
    if (sortField !== field) return <ArrowUpDown className="w-4 h-4 text-stone-400" />;
    return sortDirection === 'asc' ? 
      <ArrowUp className="w-4 h-4 text-amber-600" /> : 
      <ArrowDown className="w-4 h-4 text-amber-600" />;
  };

  return (
    <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 mb-4">
      <div className="flex items-center gap-2 flex-wrap">
        <span className="text-sm text-stone-500">Sort by:</span>
        <button
          onClick={() => onSort('name')}
          className={`flex items-center gap-1 px-3 py-1.5 rounded-lg text-xs font-medium transition-colors ${
            sortField === 'name' 
              ? 'bg-amber-100 text-amber-700' 
              : 'bg-stone-100 text-stone-600 hover:bg-stone-200'
          }`}
        >
          Name {getSortIcon('name')}
        </button>
        <button
          onClick={() => onSort('total_assigned')}
          className={`flex items-center gap-1 px-3 py-1.5 rounded-lg text-xs font-medium transition-colors ${
            sortField === 'total_assigned' 
              ? 'bg-amber-100 text-amber-700' 
              : 'bg-stone-100 text-stone-600 hover:bg-stone-200'
          }`}
        >
          Assigned {getSortIcon('total_assigned')}
        </button>
        <button
          onClick={() => onSort('total_paid')}
          className={`flex items-center gap-1 px-3 py-1.5 rounded-lg text-xs font-medium transition-colors ${
            sortField === 'total_paid' 
              ? 'bg-amber-100 text-amber-700' 
              : 'bg-stone-100 text-stone-600 hover:bg-stone-200'
          }`}
        >
          Paid {getSortIcon('total_paid')}
        </button>
        <button
          onClick={() => onSort('balance')}
          className={`flex items-center gap-1 px-3 py-1.5 rounded-lg text-xs font-medium transition-colors ${
            sortField === 'balance' 
              ? 'bg-amber-100 text-amber-700' 
              : 'bg-stone-100 text-stone-600 hover:bg-stone-200'
          }`}
        >
          Balance {getSortIcon('balance')}
        </button>
        <button
          onClick={() => onSort('status')}
          className={`flex items-center gap-1 px-3 py-1.5 rounded-lg text-xs font-medium transition-colors ${
            sortField === 'status' 
              ? 'bg-amber-100 text-amber-700' 
              : 'bg-stone-100 text-stone-600 hover:bg-stone-200'
          }`}
        >
          Status {getSortIcon('status')}
        </button>
      </div>
      
      <div className="flex items-center gap-2">
        <select
          value={itemsPerPage}
          onChange={(e) => onItemsPerPageChange(Number(e.target.value))}
          className="text-xs border border-stone-300 rounded px-2 py-1.5 bg-white"
        >
          <option value={10}>10 per page</option>
          <option value={25}>25 per page</option>
          <option value={50}>50 per page</option>
          <option value={100}>100 per page</option>
        </select>
      </div>
    </div>
  );
}
